import type { IconButtonProps as MuiIconButtonProps } from "@material-ui/core";
import { IconButton as MuiIconButton, makeStyles } from "@material-ui/core";
import clsx from "clsx";

import type { CoretexTheme } from "../theme";

const useStyles = makeStyles((theme: CoretexTheme) => ({
  icon: {
    padding: 0,
    width: 32,
    height: 32,
    "&:hover": {
      backgroundColor: theme.palette.colour.primaryBlueHover,
      "& svg > *": {
        fill: theme.palette.mono.white,
      },
    },
    "& svg > *": {
      fill: theme.palette.mono.ultraDark,
    },
  },
  selected: {
    backgroundColor: theme.palette.colour.primaryBlue,
    "& svg > *": {
      fill: theme.palette.mono.white,
    },
  },
}));

interface IconButtonProps extends MuiIconButtonProps {
  selected: boolean;
}

const IconButton = ({ selected, children, ...props }: IconButtonProps): JSX.Element => {
  const classes = useStyles();

  return (
    <MuiIconButton className={clsx(classes.icon, selected && classes.selected)} disableRipple {...props}>
      {children}
    </MuiIconButton>
  );
};

export default IconButton;
